import React from 'react'

import NavigationMenuSection from "../../menu-items/section/section"
import NavigationMenuItemUrl from "../../menu-items/menu-item-url"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"


type Props = {
    navigationSection   : NavigationSection
}

export default function NavigationMenuToolsCrm(props:Props) {

    const isManager = gd.user.acl.isManager

    return (
        <>
            <NavigationMenuSection name={"CRM"} collapsible={true} systemName="toolsCrm" counter={2}>
                <NavigationMenuItemUrl name                 = "Contacts"
                                       icon                 = "i5-crm-contact"
                                       url                  = "crm/contacts"
                                       navigationSection    = {props.navigationSection}/>
                <NavigationMenuItemUrl name                 = "Accounts"
                                       icon                 = "i5-crm-account"
                                       url                  = "crm/accounts"
                                       navigationSection    = {props.navigationSection}/>
            </NavigationMenuSection>

            {isManager &&
                <NavigationMenuSection name="Customer Portal" collapsible={true} systemName="crm-customer-portal" counter={2}>
                    <NavigationMenuItemUrl name                 = "Customers"
                                           icon                 = "i5-customer"
                                           url                  = "o/customers"
                                           navigationSection    = {props.navigationSection}/>
                    <NavigationMenuItemUrl name                 = "Customer Projects"
                                           icon                 = "ii5-project"
                                           url                  = 'crm/projects'
                                           navigationSection    = {props.navigationSection}/>
                </NavigationMenuSection>}
        </>
    )
}
